/**
 * Identity of the display the overlay window currently covers.
 *
 * The overlay is one fullscreen window that main moves between monitors, so a
 * renderer can see its viewport change but not *which* screen it landed on.
 * Main publishes the display id here on every bounds recalculation (see
 * `getOverlayWindowBounds`) and the renderer turns it into the key its
 * per-display preferences are stored under.
 */
export const OVERLAY_DISPLAY_ID_STATE_KEY = 'overlay.displayId'

/**
 * Storage key for a display. Electron's `Display.id` is what the rest of the
 * app already persists for a screen (see `SIDEPANEL_PINNED_DISPLAY_SETTING_KEY`),
 * so per-display preferences key off the same value. `null` means the display
 * is unknown — callers fall back to the display-independent preference.
 */
export function overlayDisplayKey(displayId: number | null | undefined): string | null {
  if (typeof displayId !== 'number' || !Number.isFinite(displayId)) {
    return null
  }
  return String(displayId)
}
